import React, { useState } from "react";
import AppCol from "src/commun/composants/grille/AppCol";
import styles from "src/pages/historiqueconnexion/HistoriqueConnexion.scss";
import { useAppText } from "src/commun/composants/AppText";
import AppRow from "src/commun/composants/grille/AppRow";
import RattachementForm from "src/pages/rattachement/form/RattachementForm";
import AppMessage from "src/commun/composants/AppMessage/AppMessage";
import RattachementFormSuccess from "src/pages/rattachement/form/RattachementFormSuccess";

export type RattachementCompteProps = {
  sourceUid: string | null;
  targetEmailAddress: string | null;
};

const RattachementCompte = ({ sourceUid, targetEmailAddress }: RattachementCompteProps) => {
  const { tString } = useAppText();
  const [displaySuccessMessage, setDisplaySuccessMessage] = useState(false);

  const submitSuccessHandler = () => {
    setDisplaySuccessMessage(true);
  }

  return  (
    <span className={`ferge-class`}>
      <AppRow className="justify-content-md-center">

        {sourceUid && targetEmailAddress ?
          <AppCol md={{ span: 11}}>
            <h1 className="appTitle">{tString("migration.step.1.attach.title")}</h1>
            <AppRow className={styles.container}>

              {displaySuccessMessage ?
                <RattachementFormSuccess />
                  :
                <RattachementForm sourceUid={sourceUid} targetEmailAddress={targetEmailAddress} submitSuccessHandler={submitSuccessHandler} />
              }

            </AppRow>
          </AppCol>
            :
          <AppMessage messageType="ERROR" children={tString("error.technical")} />
        }
      </AppRow>
    </span>
  );
};

export default RattachementCompte;